// notice we are destructuring the props here. You could change this to
// bring in props instead and then just add `props.` to animal, onEditClick and onDeleteClick:
// export default function AnimalItem(props)

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import styles from './Form.module.scss';
import useState from 'react-usestateref'
import AnimalForm from "./AnimalForm";
import { animalReviewMessage } from "../utils/animalReview";

export default function AnimalItem({
  animal,
  formProps,
  index,
  onDelete,
}) {
  const [, setItemState, itemStateRef] = useState(animal.itemState || 'CLOSED');
  const { setValue, formState: { errors }, watch } = formProps;

  // Watch for changes in the specific animal's form state
  const watchedAnimal = watch(`animals[${index}]`);

  const reviewMessage = animalReviewMessage(watchedAnimal.purchaseprice, watch('state'), watchedAnimal.dob);

  function onEditClick() {
    // A saved animal may need approval after the applicant changes state.
    // Keep it editable even when submission has raised a review error.
    setItemState("EDIT");
    setValue(`animals[${index}].itemState`, "EDIT");
  }

  function onDeleteClick() {
    const animalLabel = watchedAnimal.name || 'this animal';
    const lotLabel = watchedAnimal.lotno ? ` (lot #${watchedAnimal.lotno})` : '';
    if (window.confirm(`Delete ${animalLabel}${lotLabel} from this application?`)) {
      onDelete(animal,index);
    }
  }

  return (
    <>
      {reviewMessage && <div className={`${styles.error} ${styles.reviewWarning}`} role="alert">{reviewMessage}</div>}
      {
        ["FIRST","NEW","EDIT"].includes(itemStateRef.current) &&
        <AnimalForm
          animal={watchedAnimal}
          reviewMessage={reviewMessage}
          formProps={formProps}
          index={index}
          setItemState = {setItemState}
          itemStateRef = {itemStateRef}
          onDeleteClick = {onDeleteClick} />
      }
      {
        ["CLOSED"].includes(itemStateRef.current) &&
        <div className={styles.animalRollup}>
          <div>
            <label>Lot Number</label>
            <div className={styles.rollupValue}># {watchedAnimal.lotno}</div>
          </div>
          <div>
            <label>Purchase Price</label>
            <div className={styles.rollupValue}>$ {watchedAnimal.purchaseprice}</div>
          </div>
          <div className={styles.actionBtns}>
            <button type="button" className={styles.editButton} onClick={onEditClick}><FontAwesomeIcon icon={faEdit}/>Edit</button>
            <button type="button" className={styles.editButton} onClick={onDeleteClick}><FontAwesomeIcon icon={faTrash}/>Delete</button>
          </div>
        </div>
      }
      {itemStateRef.current === "CLOSED" && errors.animals?.[index]?.purchaseprice
        && errors.animals[index].purchaseprice.message !== reviewMessage && (
        <div className={styles.error} role="alert">{errors.animals[index].purchaseprice.message}</div>
      )}

    </>);

}
